<!-- 合同详情 -->
<template>
  <div>
    <p style="margin:0pt; orphans:0; text-align:center; widows:0">
      <span
        style="font-family:仿宋; font-size:22pt; font-weight:bold"
      >{{ APP_PROVINCE_CITY[0] }}文交现货购销平台</span>
    </p>
    <p style="margin:0pt; orphans:0; text-align:center; widows:0">
      <span
        style="font-family:仿宋; font-size:22pt; font-weight:bold"
      >交易商商品</span><span
        style="font-family:仿宋; font-size:22pt; font-weight:bold"
      >订单</span><span
        style="font-family:仿宋; font-size:22pt; font-weight:bold"
      >购销合同</span>
    </p>
    <p style="margin:0pt; orphans:0; text-align:center; widows:0">
      <span
        style="font-family:仿宋; font-size:14pt; font-weight:bold"
      >&nbsp;</span>
    </p>
    <!-- <p style="margin:0pt; orphans:0; text-align:justify; widows:0">
      <span
        style="font-family:仿宋; font-size:14pt; font-weight:normal"
      ></span>
      <span style="font-family:仿宋; font-size:16pt; font-weight:bold">
        交易账号（卖</span><span style="font-family:仿宋; font-size:16pt; font-weight:bold">方）：
        <span style="font-family:仿宋; font-size:16pt; font-weight:bold">{{ this.bsFlag=='S' ? ownSideNameGetter : analogueMobileMesGetter.join(",") }}</span>
      </span>

    </p> -->
    <div>
      <div style="display:flex">
        <div style="font-family:仿宋; font-size:16pt; font-weight:bold">交易账号（卖方）：</div>
        <span style="font-family:仿宋; font-size:16pt; font-weight:bold">{{ this.bsFlag=='S' ? ownSideNameGetter : analogueMobileMesGetter.join(",") }}</span>
      </div>
      <div style="display:flex">
        <div style="font-family:仿宋; font-size:16pt; font-weight:bold">交易账号（买方）：</div>
        <span style="font-family:仿宋; font-size:16pt; font-weight:bold">{{ this.bsFlag=='B' ? ownSideNameGetter : analogueMobileMesGetter.join(",") }}</span>
      </div>
    </div>
    <!-- {{ ownSideNameGetter }} -->
    <!-- <p
      style="margin:0pt; orphans:0; text-align:justify; widows:0"
    >
      <span
        style="font-family:仿宋; font-size:16pt; font-weight:bold"
      >交易账号（买</span><span
        style="font-family:仿宋; font-size:16pt; font-weight:bold"
      >方）：<span style="font-family:仿宋; font-size:16pt; font-weight:bold">{{ this.bsFlag=='B' ? ownSideNameGetter : analogueMobileMesGetter.join(",") }}</span></span>
    </p> -->
    <p
      style="margin:0pt; orphans:0; text-align:justify; text-indent:33pt; widows:0"
    >
      <span style="font-family:仿宋; font-size:14pt">&nbsp;</span>
    </p>
    <p style="font-size:15pt; line-height:200%; margin:0pt; text-indent:21pt">
      <span style="font-family:宋体; font-size:15pt">卖方与买</span><span
        style="font-family:宋体; font-size:15pt"
      >方根据《中华人民共和国合同法》、《中华人民共和国物权法》等有关法律的规定及《{{ APP_PROVINCE_CITY[0] }}文交现货购销平台</span><span style="font-family:宋体; font-size:15pt">订单</span><span
        style="font-family:宋体; font-size:15pt"
      >交易规则》等管理办法的规定，遵循平等、自愿、互利、互惠原则，通过{{ APP_PROVINCE_CITY[0] }}文交现货购销平台</span><span style="font-family:宋体; font-size:15pt">订单</span><span
        style="font-family:宋体; font-size:15pt"
      >交易系统报价、成交达成如下协议。</span>
    </p>
    <p style="font-size:15pt; line-height:200%; margin:0pt">
      <span
        style="font-family:宋体; font-size:15pt"
      >&nbsp;&nbsp; 一、合同主体说明</span>
    </p>
    <p style="font-size:15pt; line-height:200%; margin:0pt">
      <span
        style="font-family:宋体; font-size:15pt"
      >&nbsp;&nbsp;
        {{ APP_PROVINCE_CITY[0] }}文交现货购销平台作为组织商品买卖的第三方信息平台，为商品购销双方的要约、承诺、合同成立、合同转让、合同变更以及款项结算等提供第三方平台服务。{{ APP_PROVINCE_CITY[0] }}文交现货购销平台不是商品购销合同的当事人，不参与任何商品买卖，不享有商品购销合同项下购销双方的权利，不承担商品购销合同项下购销双方的义务，不承担商品购销合同未生效、有效、效力待定或者无效、解除、终止所产生的任何法律责任。</span>
    </p>
    <p style="font-size:15pt; line-height:200%; margin:0pt">
      <span
        style="font-family:宋体; font-size:15pt"
      >&nbsp;&nbsp;&nbsp; 二、商品购销合同的基本内容：</span>
    </p>
    <p style="font-size:15pt; line-height:200%; margin:0pt">
      <span
        style="font-family:宋体; font-size:15pt"
      >&nbsp;&nbsp;&nbsp; 1、商品信息</span>
    </p>
    <p style="font-size:15pt; line-height:200%; margin:0pt">
      <span style="font-family:宋体; font-size:15pt">&nbsp;&nbsp;&nbsp; </span><span
        style="font-family:宋体; font-size:15pt"
      >卖方在{{ APP_PROVINCE_CITY[0] }}文交现货购销平台订单</span><span
        style="font-family:宋体; font-size:15pt"
      >交易系统出售的商品信息如下：</span>
    </p>
    <p style="font-size:15pt; line-height:200%; margin:0pt">
      <span
        style="font-family:宋体; font-size:15pt"
      >&nbsp;&nbsp; 商品名称：{{ unit }}</span>
    </p>
    <p style="font-size:15pt; line-height:200%; margin:0pt">
      <span
        style="font-family:宋体; font-size:15pt"
      >&nbsp;&nbsp; 商品代码：{{ symbolId }}</span>
    </p>
    <p style="font-size:15pt; line-height:200%; margin:0pt">
      <span
        style="font-family:宋体; font-size:15pt"
      >&nbsp;&nbsp; 商品数量：{{ amount }}</span>
    </p>
    <p style="font-size:15pt; line-height:200%; margin:0pt">
      <span
        style="font-family:宋体; font-size:15pt"
      >&nbsp;&nbsp; 交易方向：{{ this.bsFlag=='S' ? '卖出' : '买入' }}</span>
    </p>
    <p style="font-size:15pt; line-height:200%; margin:0pt">
      <span
        style="font-family:宋体; font-size:15pt"
      >&nbsp;&nbsp; 商品规格和型号：</span>
    </p>
    <p style="font-size:15pt; line-height:200%; margin:0pt">
      <span
        style="font-family:宋体; font-size:15pt"
      >&nbsp;&nbsp; 商品价格：{{ price }}</span>
    </p>
    <p style="font-size:15pt; line-height:200%; margin:0pt">
      <span
        style="font-family:宋体; font-size:15pt"
      >&nbsp;&nbsp; 商品的包装方式：（如需要可加上）</span>
    </p>
    <p style="font-size:15pt; line-height:200%; margin:0pt">
      <span
        style="font-family:宋体; font-size:15pt"
      >&nbsp;&nbsp; 成交金额：{{ transactionVolume }}</span>
    </p>
    <p style="font-size:15pt; line-height:200%; margin:0pt">
      <span
        style="font-family:宋体; font-size:15pt"
      >&nbsp;&nbsp; 成交日期：_________年_________月_________日。</span>
    </p>
    <p style="font-size:15pt; line-height:200%; margin:0pt">
      <span
        style="font-family:宋体; font-size:15pt"
      >&nbsp;&nbsp;&nbsp; 2、商品质量标准</span>
    </p>
    <p style="font-size:15pt; line-height:200%; margin:0pt">
      <span
        style="font-family:宋体; font-size:15pt"
      >&nbsp;&nbsp;&nbsp;
        商品有国家统一质量标准的，按照国家统一质量标准执行；没有国家统一质量标准的，应符合同行业同一品质质量标准的要求。</span>
    </p>
    <p style="font-size:15pt; line-height:200%; margin:0pt">
      <span
        style="font-family:宋体; font-size:15pt"
      >&nbsp;&nbsp;&nbsp; 3、商品成交</span>
    </p>
    <p style="font-size:15pt; line-height:200%; margin:0pt; text-indent:21pt">
      <span style="font-family:宋体; font-size:15pt">买</span><span style="font-family:宋体; font-size:15pt">方在{{ APP_PROVINCE_CITY[0] }}文交现货购销平台</span><span
        style="font-family:宋体; font-size:15pt"
      >订单交易系统点击购买并确认交易后，即视为买方同意以卖</span><span
        style="font-family:宋体; font-size:15pt"
      >方提出的商品数量和价格成交。</span>
    </p>
    <p style="font-size:15pt; line-height:200%; margin:0pt; text-indent:21pt">
      <span
        style="font-family:宋体; font-size:15pt"
      >买卖成功后，成交商品在所属仓库的货物的所有权归买方所有，买方可在交收期内</span><span style="font-family:宋体; font-size:15pt">申请提货。</span>
    </p>
    <p style="font-size:15pt; line-height:200%; margin:0pt; text-indent:21pt">
      <span style="font-family:宋体; font-size:15pt">4、</span><span
        style="font-family:宋体; font-size:15pt"
      >商品的存储地点和交付：</span>
    </p>
    <p style="font-size:15pt; line-height:200%; margin:0pt; text-indent:28pt">
      <span
        style="font-family:宋体; font-size:15pt"
      >本交易商品存储于＿__________,</span><span style="font-family:宋体; font-size:15pt">卖方与买</span><span
        style="font-family:宋体; font-size:15pt"
      >方均明确知悉，交易完成后，双方视为交付。仓储及运输事宜按照{{ APP_PROVINCE_CITY[0] }}文交现货购销平台的相关规定执行。</span>
    </p>
    <p style="font-size:15pt; line-height:200%; margin:0pt">
      <span
        style="font-family:宋体; font-size:15pt"
      >&nbsp;&nbsp;&nbsp; 三、款项结算</span>
    </p>
    <p style="font-size:15pt; line-height:200%; margin:0pt; text-indent:21pt">
      <span style="font-family:宋体; font-size:15pt">买方买入卖</span><span
        style="font-family:宋体; font-size:15pt"
      >方的商品数量为&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
        ，应付款项为&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span><span style="font-family:宋体; font-size:15pt">元，该款项在买</span><span
        style="font-family:宋体; font-size:15pt"
      >方提交确认交易指令后，经{{ APP_PROVINCE_CITY[0] }}文交现货购销平台</span><span style="font-family:宋体; font-size:15pt">订单</span><span style="font-family:宋体; font-size:15pt">交易系统</span><span
        style="font-family:宋体; font-size:15pt"
      >将商品款项转至卖方交易账户，同时卖方交易账户下的商品权益随即转至买</span><span style="font-family:宋体; font-size:15pt">方所有。</span>
    </p>
    <p
      style="font-size:15pt; line-height:200%; margin:0pt; orphans:0; text-align:justify; widows:0"
    >
      <span style="font-family:宋体; font-size:15pt">&nbsp;&nbsp; 四、</span><span
        style="font-family:宋体; font-size:15pt"
      >根据{{ APP_PROVINCE_CITY[0] }}文交现货购销平台的规定，买</span><span style="font-family:宋体; font-size:15pt">方提取货物</span><span
        style="font-family:宋体; font-size:15pt"
      >时，应明确填写收货人姓名、地点、联系电话信息，如信息错误，由买方承担不良后果，由此产生的运输费用由买</span><span style="font-family:宋体; font-size:15pt">方承担。</span>
    </p>
    <p
      style="font-size:15pt; line-height:200%; margin:0pt; orphans:0; text-align:justify; widows:0"
    >
      <span
        style="font-family:宋体; font-size:15pt"
      >&nbsp;&nbsp;&nbsp;&nbsp; </span><span
        style="font-family:宋体; font-size:15pt"
      >商品需通过运输交付的，自商品交付第一承运人时，商品风险归买</span><span style="font-family:宋体; font-size:15pt">方承担。</span>
    </p>
    <p
      style="font-size:15pt; line-height:200%; margin:0pt; orphans:0; text-align:justify; widows:0"
    >
      <span
        style="font-family:宋体; font-size:15pt"
      >&nbsp;&nbsp; 五、提出异议的时间和方法：</span>
    </p>
    <p
      style="font-size:15pt; line-height:200%; margin:0pt; orphans:0; text-align:justify; widows:0"
    >
      <span style="font-family:宋体; font-size:15pt">&nbsp;&nbsp; 1.</span><span style="font-family:宋体; font-size:15pt">买</span><span
        style="font-family:宋体; font-size:15pt"
      >方如收到商品后，发现品种、型号、规格、花色和质量不合规定或约定，应在妥为保管商品的同时，自收到商品后____</span><span style="font-family:宋体; font-size:15pt">日内向卖</span><span
        style="font-family:宋体; font-size:15pt"
      >方提出书面异议；未及时提出异议或者自收到商品之日起___</span><span style="font-family:宋体; font-size:15pt">日内未通知卖</span><span
        style="font-family:宋体; font-size:15pt"
      >方的，视为商品合乎规定。
      </span>
    </p>
    <p
      style="font-size:15pt; line-height:200%; margin:0pt; orphans:0; text-align:justify; widows:0"
    >
      <span style="font-family:宋体; font-size:15pt">&nbsp;&nbsp; 2.</span><span style="font-family:宋体; font-size:15pt">买</span><span
        style="font-family:宋体; font-size:15pt"
      >方因使用、保管、保养不善等造成商品产品质量下降的，不得提出异议。
      </span>
    </p>
    <p
      style="font-size:15pt; line-height:200%; margin:0pt; orphans:0; text-align:justify; widows:0"
    >
      <span style="font-family:宋体; font-size:15pt">&nbsp;&nbsp; 3.</span><span style="font-family:宋体; font-size:15pt">卖方在接到买</span><span
        style="font-family:宋体; font-size:15pt"
      >方书面异议后，应在_____</span><span
        style="font-family:宋体; font-size:15pt"
      >日内负责处理并通知买方处理情况，否则，即视为默认买</span><span style="font-family:宋体; font-size:15pt">方提出的异议。 </span>
    </p>
    <p style="font-size:15pt; line-height:200%; margin:0pt">
      <span
        style="font-family:宋体; font-size:15pt"
      >&nbsp;&nbsp;&nbsp; 六、违约责任</span>
    </p>
    <p style="font-size:15pt; line-height:200%; margin:0pt">
      <span
        style="font-family:宋体; font-size:15pt"
      >&nbsp;&nbsp;&nbsp; 下列行为属于违约行为，须由违约方承担违约责任：</span>
    </p>
    <p style="font-size:15pt; line-height:200%; margin:0pt">
      <span style="font-family:宋体; font-size:15pt">&nbsp;&nbsp; </span><span style="font-family:宋体; font-size:15pt">（一）买</span><span
        style="font-family:宋体; font-size:15pt"
      >方未按规定及时足额支付货款及其它相关款项的；</span>
    </p>
    <p style="font-size:15pt; line-height:200%; margin:0pt">
      <span style="font-family:宋体; font-size:15pt">&nbsp;&nbsp; </span><span style="font-family:宋体; font-size:15pt">（二）卖</span><span
        style="font-family:宋体; font-size:15pt"
      >方未按规定及时交付足额商品的；</span>
    </p>
    <p style="font-size:15pt; line-height:200%; margin:0pt">
      <span style="font-family:宋体; font-size:15pt">&nbsp;&nbsp; </span><span style="font-family:宋体; font-size:15pt">（三）卖</span><span
        style="font-family:宋体; font-size:15pt"
      >方交付的货物不符合合同约定标准的；</span>
    </p>
    <p style="font-size:15pt; line-height:200%; margin:0pt">
      <span
        style="font-family:宋体; font-size:15pt"
      >&nbsp;&nbsp; （四）{{ APP_PROVINCE_CITY[0] }}文交现货购销平台认定的其它违约行为。</span>
    </p>
    <p style="font-size:15pt; line-height:200%; margin:0pt">
      <span
        style="font-family:宋体; font-size:15pt"
      >&nbsp;&nbsp;&nbsp; 七、争议解决</span>
    </p>
    <p style="font-size:15pt; line-height:200%; margin:0pt; text-indent:21pt">
      <span style="font-family:宋体; font-size:15pt">本合</span><span style="font-family:宋体; font-size:15pt">同履行过程卖方与买</span><span
        style="font-family:宋体; font-size:15pt"
      >方产生争议的，双方可协商解决，也可向{{ APP_PROVINCE_CITY[0] }}文交现货购销平台申请调解，如协商或调解不成，双方一致同意提交{{ APP_PROVINCE_CITY[1] }}仲裁委员会依其现行有效规则予以仲裁，仲裁地：{{ APP_PROVINCE_CITY[0] }}{{ APP_PROVINCE_CITY[1] }}，仲裁决议是终局的，对双方均由约束力。</span>
    </p>
    <p style="font-size:15pt; line-height:200%; margin:0pt">
      <span
        style="font-family:宋体; font-size:15pt"
      >&nbsp;&nbsp;&nbsp; 八、明示条款</span>
    </p>
    <p style="font-size:15pt; line-height:200%; margin:0pt; text-indent:21pt">
      <span style="font-family:宋体; font-size:15pt">1、</span><span style="font-family:宋体; font-size:15pt">卖方与买</span><span
        style="font-family:宋体; font-size:15pt"
      >方双方确认：对本合同的条款在交易前已充分阅读，完全理解每一条款的真实意思表示，愿意签订并遵守本合同的全部约定。</span>
    </p>
    <p style="font-size:15pt; line-height:200%; margin:0pt; text-indent:21pt">
      <span style="font-family:宋体; font-size:15pt">2、</span><span style="font-family:宋体; font-size:15pt">卖方与买</span><span
        style="font-family:宋体; font-size:15pt"
      >方在交易前已明确知悉享有的全部合同权利和义务，点击交易成功后，作为签订本合同和合同生效的唯一要件。</span>
    </p>
    <p style="font-size:15pt; line-height:200%; margin:0pt; text-indent:28pt">
      <span style="font-family:宋体; font-size:15pt">九、</span><span style="font-family:宋体; font-size:15pt">卖方与买</span><span
        style="font-family:宋体; font-size:15pt"
      >方填写的商品交易的信息，包括姓名、地址、联系电话、电子邮箱均保证属实。如一方地址、电话、传真号码有变更，应在变更后的___日内书面通知对方及{{ APP_PROVINCE_CITY[0] }}文交现货购销平台，否则应承担一切不利后果。</span>
    </p>
    <p style="font-size:15pt; line-height:200%; margin:0pt; text-indent:28pt">
      <span style="font-family:宋体; font-size:15pt">十、合同生效及其他</span>
    </p>
    <p style="font-size:15pt; line-height:200%; margin:0pt">
      <span style="font-family:宋体; font-size:15pt">&nbsp;&nbsp;&nbsp; 1</span><span
        style="font-family:宋体; font-size:15pt"
      >、本合同于卖方与买方通过{{ APP_PROVINCE_CITY[0] }}文交现货购销平台订单</span><span
        style="font-family:宋体; font-size:15pt"
      >交易系统报价成交时即生效，对双方具有约束力。如有需要书面合同，双方均可通过{{ APP_PROVINCE_CITY[0] }}文交现货购销平台交易系统自行打印本合同。</span>
    </p>
    <p style="font-size:15pt; line-height:200%; margin:0pt">
      <span
        style="font-family:宋体; font-size:15pt"
      >&nbsp;&nbsp;&nbsp;
        2、其他未尽事宜，依照{{ APP_PROVINCE_CITY[0] }}文交现货购销平台的有关规定执行。</span>
    </p>
    <p style="font-size:15pt; line-height:200%; margin:0pt; text-indent:30pt">
      <span
        style="font-family:宋体; font-size:15pt"
      >3、如果双方未能在{{ APP_PROVINCE_CITY[0] }}文交现货购销平台交易系统上达成成交，此协议仅为意向协议，双方均不承担任何法律责任。</span>
    </p>
    <p style="font-size:15pt; line-height:200%; margin:0pt; text-indent:30pt">
      <span
        style="font-family:宋体; font-size:15pt; font-weight:bold; text-decoration:underline"
      >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
        以下无正文&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
      </span>
    </p>
    <p style="font-size:15pt; line-height:200%; margin:0pt">
      <span style="font-family:宋体; font-size:15pt">&nbsp;</span>
    </p>
    <p style="font-size:15pt; line-height:200%; margin:0pt">
      <span style="font-family:宋体; font-size:15pt">&nbsp;</span>
    </p>
    <p style="font-size:15pt; line-height:200%; margin:0pt; text-indent:21pt">
      <span style="font-family:宋体; font-size:15pt">卖</span><span style="font-family:宋体; font-size:15pt">方：</span><span style="font-family:宋体; font-size:15pt">{{ this.bsFlag=='S' ? ownSideNameGetter : analogueMobileMesGetter.join(",") }}</span>
    </p>
    <p
      style="font-size:15pt; line-height:200%; margin:0pt 15pt 0pt 0pt; text-align:right; text-indent:21pt"
    >
      <span
        style="font-family:宋体; font-size:15pt"
      >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span><span style="font-family:宋体; font-size:15pt">{{ systemTimeGetter|dateFormateDayCh }}</span>
    </p>
    <p style="font-size:15pt; line-height:200%; margin:0pt; text-indent:21pt">
      <span style="font-family:宋体; font-size:15pt">&nbsp;</span>
    </p>
    <p style="font-size:15pt; line-height:200%; margin:0pt; text-indent:21pt">
      <span style="font-family:宋体; font-size:15pt">买</span><span style="font-family:宋体; font-size:15pt">方：</span><span style="font-family:宋体; font-size:15pt">{{ this.bsFlag=='B' ? ownSideNameGetter : analogueMobileMesGetter.join(",") }}</span>
    </p>
    <p style="font-size:15pt; line-height:200%; margin:0pt; text-indent:21pt">
      <span style="font-family:宋体; font-size:15pt">&nbsp;</span>
    </p>
    <p
      style="font-size:15pt; line-height:200%; margin:0pt 15pt 0pt 0pt; text-align:right; text-indent:21pt"
    >
      <span style="font-family:宋体; font-size:15pt">{{ systemTimeGetter|dateFormateDayCh }}</span>
    </p>
    <p style="margin:0pt; orphans:0; text-align:justify; widows:0">
      <span style="font-family:仿宋; font-size:14pt">&nbsp;</span>
    </p>
    <p style="margin:0pt; orphans:0; text-align:justify; widows:0">
      <span style="font-family:仿宋; font-size:14pt">&nbsp;</span>
    </p>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
export default {
  props: [
    'bsFlag',
    'price',
    'amount',
    'transactionVolume'
  ],
  data() {
    return {
      APP_PROVINCE_CITY: window.g.APP_PROVINCE_CITY
    }
  },
  created() {
  },
  computed: {
    ...mapGetters(['systemTimeGetter', 'sessionInfoGetter', 'analogueMobileMesGetter', 'ownSideNameGetter']),
    symbolId() {
      const item = this.$store.state.hqData.item.symbolId
      if (item) {
        return item
      } else {
        if (this.$store.state.hqData.marketDetails.length > 0) {
          return this.$store.state.hqData.marketDetails[0].symbolId
        } else {
          return '--'
        }
      }
    },
    unit() {
      const item = this.$store.state.hqData.item.symbol
      if (item) {
        const strDian = item.split('/')
        const strDianQian = strDian[0]
        return strDianQian
      } else {
        if (this.$store.state.hqData.marketDetails.length > 0) {
          return this.$store.state.hqData.marketDetails[0].symbol.split('/')[0]
        } else {
          return ''
        }
      }
    }
  }
}
</script>

<style></style>
